// Timetable data
export function getTimetableData() {
  return {
    classTypeMap: {
      "TAEKWON-DO":          "TAEKWON-DO",
      "KICKBOXING MUAY THAI": "KICKBOXING",
      "ZUMBA DANCE":          "ZUMBA FITNESS",
    },

    venues: [
      { id: 1, name: "STUDIO V FITNESS CENTER",    location: "Sungai Buloh" },
      { id: 2, name: "SJK(C) KUANG",               location: "Kuang, Sungai Buloh" },
      { id: 3, name: "KLBC",                        location: "Bukit Bintang, Kuala Lumpur" },
      { id: 4, name: "TIC TAC TOTS DAYCARE CENTRE", location: "North Kiara, Bukit Segambut" }
    ],

    // These are the ONLY 3 options shown in the filter sidebar
    filters: [
      { id: 1, name: "TAEKWON-DO" },
      { id: 2, name: "KICKBOXING MUAY THAI" },
      { id: 3, name: "ZUMBA DANCE" },
    ],

    clubs: {
      monday: {
        id: 1,
        morning: [],
        afternoon: [],
        evening: [
          { name: "TIC TAT TOTS",  time: "4.00PM - 5.00PM",   duration: "60min",  color: "#977904", venueId: 4 },
          { name: "KICKBOXING",    time: "6.30PM - 7.30PM",   duration: "60min",  color: "#89CFF0", venueId: 1 },
          { name: "TAEKWON-DO",    time: "7.30PM - 9.00PM",   duration: "90min",  color: "#9D9D9C", venueId: 1 },
          { name: "ZUMBA FITNESS", time: "9.00PM - 10.00PM",  duration: "60min",  color: "#000080", venueId: 1 },
        ]
      },

      tuesday: {
        id: 2,
        morning: [],
        afternoon: [],
        evening: [
          { name: "KICKBOXING",    time: "6.30PM - 7.30PM",  duration: "60min",  color: "#89CFF0", venueId: 1 },
          { name: "TAEKWON-DO",    time: "7.30PM - 9.00PM",  duration: "90min",  color: "#9D9D9C", venueId: 1 },
          { name: "ZUMBA FITNESS", time: "9.00PM - 10.00PM", duration: "60min",  color: "#000080", venueId: 1 },
        ]
      },

      wednesday: {
        id: 3,
        morning: [],
        afternoon: [],
        evening: [
          { name: "KICKBOXING",  time: "6.30AM - 7.30PM\n7.30AM - 8.30PM", duration: "120min", color: "#89CFF0", venueId: 1 },
          { name: "TAEKWON-DO",  time: "8.30AM - 10.00PM", subtitle: "(SENIOR BLACK BELT)", duration: "90min",  color: "#9D9D9C", venueId: 1 },
        ]
      },

      thursday: {
        id: 4,
        morning: [],
        afternoon: [],
        evening: [
          { name: "KLBC",        time: "4.00PM - 5.30PM",  duration: "90min",  color: "#2c8904", venueId: 3 },
          { name: "KICKBOXING",  time: "6.30PM - 7.30PM",  subtitle: "(ADVANCE CLASS)", duration: "60min",  color: "#89CFF0", venueId: 1 },
          { name: "TAEKWON-DO",  time: "7.30PM - 9.00PM",  duration: "90min",  color: "#9D9D9C", venueId: 1 },
          { name: "ZUMBA FITNESS", time: "9.00PM - 10.00PM", duration: "60min", color: "#000080", venueId: 1 },
        ]
      },

      friday: {
        id: 5,
        morning: [
          { name: "SJKC KUANG", time: "9.30AM - 11.00AM", duration: "90min", color: "#b1e34f", venueId: 2 },
        ],
        afternoon: [
          { name: "SJKC KUANG", time: "1.00AM - 2.30PM",  duration: "90min", color: "#b1e34f", venueId: 2 },
        ],
        evening: [
          { name: "KICKBOXING", time: "6.30PM - 7.30PM\n7.30PM - 8.30PM", duration: "120min", color: "#89CFF0", venueId: 1 },
          { name: "TAEKWON-DO", time: "8.30PM - 10.00PM", subtitle: "(SENIORS CLASS)", duration: "90min",  color: "#9D9D9C", venueId: 1 },
        ]
      },

      saturday: {
        id: 6,
        morning: [
          { name: "KICKBOXING",  time: "8.00AM - 9.00AM",   duration: "60min",  color: "#89CFF0", venueId: 1 },
          { name: "TAEKWON-DO",  time: "10.00AM - 11.30AM", duration: "90min",  color: "#9D9D9C", venueId: 1 },
          { name: "TAEKWON-DO",  time: "11.30AM - 1.00PM", subtitle: "(SENIORS CLASS)", duration: "90min", color: "#9D9D9C", venueId: 1 },
        ],
        afternoon: [],
        evening: []
      },

      sunday: {
        id: 7,
        morning: [],
        afternoon: [],
        evening: []
      }
    }
  }
}